import { createColumnHelper } from "@tanstack/react-table"
import { TableCellEditable } from "../../table/table-editable/TableCellEditable"
import { ButtonEditCell } from "../../table/table-editable/ButtonEditCell"
import { Orders } from "../../../model/naglog/IOrdes"
import { IToast } from "../../../model/naglog/IToast"
import { IEstimateFeeRes } from "../../../model/ahamove/UrlResponseData"
import { IProduct } from "../../../model/wms/IProduct"


// tạo column table dựa trên type
const columnHelper = createColumnHelper<IProduct>()
export const PRODUCT_COLUMNS_WITHOUT_ACTION = [
  columnHelper.accessor('id', {
    header: 'TT',
    meta: {
      type: 'read',
    }
  }),
  columnHelper.accessor('ma', {
    header: 'Mã sản phẩm',
    meta: {
      type: 'text'
    }
  }),
  columnHelper.accessor('ten', {
    header: 'Tên sản phẩm',
    meta: {
      type: 'text'
    }
  }),
  columnHelper.accessor('soLuong', {
    header: 'Số lượng',
    meta: {
      type: 'number',
    }
  }),
  columnHelper.accessor('donViTinh', {
    header: 'Đơn vị tính',
    meta: {
      type: 'select',
      options: [
        { value: '', label: '-' },
        { value: 'chiec', label: 'Chiếc' },
        { value: 'cai', label: 'Cái' },
        { value: 'thung', label: 'Thùng' },
        { value: 'bo', label: 'Bộ' },
      ]
    }
  }),
  columnHelper.accessor('theTich', {
    header: 'Thể tích',
    meta: {
      type: 'number',
    }
  }),
  columnHelper.accessor('trongLuong', {
    header: 'Trọng lượng',
    meta: {
      type: 'number',
    }
  }),
]

export const PRODUCT_COLUMNS_WITH_ACTION = [
  columnHelper.accessor('id', {
    header: 'TT',
    cell: TableCellEditable,
    meta: {
      type: 'read',
    }
  }),
  columnHelper.accessor('ma', {
    header: 'Mã sản phẩm',
    cell: TableCellEditable,
    meta: {
      type: 'text'
    }
  }),
  columnHelper.accessor('ten', {
    header: 'Tên sản phẩm',
    cell: TableCellEditable,
    meta: {
      type: 'text'
    }
  }),
  columnHelper.accessor('soLuong', {
    header: 'Số lượng',
    cell: TableCellEditable,
    meta: {
      type: 'number',
    }
  }),
  columnHelper.accessor('donViTinh', {
    header: 'Đơn vị tính',
    cell: TableCellEditable,
    meta: {
      type: 'select',
      options: [
        { value: '', label: '-' },
        { value: 'chiec', label: 'Chiếc' },
        { value: 'cai', label: 'Cái' },
        { value: 'thung', label: 'Thùng' },
        { value: 'bo', label: 'Bộ' },
      ]
    }
  }),
  columnHelper.accessor('theTich', {
    header: 'Thể tích',
    cell: TableCellEditable,
    meta: {
      type: 'number',
    }
  }),
  columnHelper.accessor('trongLuong', {
    header: 'Trọng lượng',
    cell: TableCellEditable,
    meta: {
      type: 'number',
    }
  }),
  // thêm cột feature
  columnHelper.display({
    header: 'Feature',
    id: 'edit',
    cell: ButtonEditCell
  })
]


export const NEW_PRODUCT: IProduct = {
  id: 0,
  ma: '',
  ten: '',
  soLuong: 0,
  theTich: 0,
  trongLuong: 0,
  donViTinh: ''
}


export const INIT_TOAST: IToast = { isShow: false, body: undefined, position: 'top-end', title: undefined, type: undefined }

export const ESTIMATE_FEE_DATA: IEstimateFeeRes =
{
  is_loading: false,
  currency: 'VND',
  distance: 0,
  duration: 0,
  stoppoint_price: 0,
  subtotal_price: 0,
  total_price: 0,
  total_pay: 0,
  distance_price: 0
}
export const PRODUCT_DATA: IProduct[] = [
  {
    id: 1,
    ma: 'NAG0133',
    ten: 'Nồi cơm điện 1.8L Nagakawa NAG0133',
    soLuong: 4,
    theTich: 4,
    trongLuong: 8,
    donViTinh: 'chiec'
  },
  {
    id: 2,
    ma: 'NAG013401',
    ten: 'Nồi cơm điện 1L Nagakawa NAG0134 (hồng, trắng)',
    soLuong: 4,
    theTich: 8,
    trongLuong: 7,
    donViTinh: 'chiec'
  },
  {
    id: 3,
    ma: 'NAG0718',
    ten: 'Bếp điện từ Nagakawa NAG0718',
    soLuong: 4,
    theTich: 8,
    trongLuong: 8,
    donViTinh: 'cái'
  },
  {
    id: 4,
    ma: 'NAG0718',
    ten: 'Lẩu điện Nagakawa NAG1902',
    soLuong: 4,
    theTich: 8,
    trongLuong: 8,
    donViTinh: 'chiec'
  },
]

export const PRODUCT_DATA_PATH: IProduct[] = [
  {
    id: 1,
    ma: 'NAG0133',
    ten: 'Nồi cơm điện 1.8L Nagakawa NAG0133',
    soLuong: 4,
    theTich: 4,
    trongLuong: 8,
    donViTinh: 'chiec'
  },
  {
    id: 2,
    ma: 'NAG013401',
    ten: 'Nồi cơm điện 1L Nagakawa NAG0134 (hồng, trắng)',
    soLuong: 4,
    theTich: 8,
    trongLuong: 7,
    donViTinh: 'chiec'
  },
]



export const ORDER_ONCE_PATH_DATA: Orders = new Orders(
  {
    date: '2024-01-22',
    time: '15:00',
    is_order_now: false,
    path: [
      {
        sender_name: 'Nguyễn Phú Huy',
        sender_mobile: '0355579902',
        address: '275 Đ. Nguyễn Trãi, Thanh Xuân Trung, Thanh Xuân, Hà Nội',
      },
      {
        name: 'Hạnh Lưu',
        mobile: '0355529588',
        address: '192 P. Hào Nam, Chợ Dừa, Đống Đa, Hà Nội',
        level: 1,
        tracking_number: 'XMT/395/01/24',
        remarks: 'BLĐ tặng ngoại giao',
        items: PRODUCT_DATA_PATH
      }
    ],
    items: PRODUCT_DATA_PATH,
    action: {
      can_estimate_fee: false,
      is_loading_fee: false,
      is_sending: false
    }
  }

)

export const ORDER_MUTIL_PATH_DATA: Orders = new Orders(
  {
    date: '2024-01-22',
    time: '15:00',
    is_order_now: false,
    path: [
      {
        sender_name: 'Nguyễn Phú Huy',
        sender_mobile: '0355579902',
        address: '275 Đ. Nguyễn Trãi, Thanh Xuân Trung, Thanh Xuân, Hà Nội',
      },
      {
        name: 'Hạnh Lưu',
        mobile: '0355529588',
        address: '192 P. Hào Nam, Chợ Dừa, Đống Đa, Hà Nội',
        level: 1,
        tracking_number: 'XMT/395/01/24',
        remarks: 'BLĐ tặng ngoại giao',
      },
      {
        name: 'Hưng Huỳnh',
        mobile: '0355553142',
        address: 'phường Hàng Buồm, quận Hoàn Kiếm, chỉ cách Hồ Gươm',
        level: 2,
        tracking_number: 'XMT/394/01/24',
        remarks: 'Xuất bán TTC LX Vương - dt:  0865733298  bx: BS:29C-012.05',
      },
      {
        name: 'Gái Quỳnh',
        mobile: '0555593706',
        address: '11 P. Hàng Vôi, Lý Thái Tổ, Hoàn Kiếm, Hà Nội',
        level: 3,
        tracking_number: 'XMT/393/01/24',
        remarks: 'Xuất bán MK Xe Phi-ĐTLX:0974 .980.917-BS:88C-24200 2.5T',
      },
      {
        name: 'Bá Chí',
        mobile: '0355555237',
        address: '19C Hoàng Diệu, phường Điện Biên, quận Ba Đình',
        level: 4,
        tracking_number: 'XMT/392/01/24',
        remarks: 'Trả thưởng đơn chào xuân đà lạt 2024',
      },
      {
        name: 'Đào Ninh',
        mobile: '0355596811',
        address: '40 Nhà Chung, Hàng Trống, Hoàn Kiếm, Hà Nội',
        level: 5,
        tracking_number: 'XMT/391/01/24',
        remarks: 'Trả thưởng cuối năm 2023',
      },
      {
        name: 'Mai Võ',
        mobile: '0355560922',
        address: 'Đ. Nguyễn Văn Huyên, Quan Hoa, Cầu Giấy, Hà Nội',
        level: 6,
        tracking_number: 'XMT/390/01/24',
        remarks: 'Xuất bán HASAKI Xe Phi-ĐTLX:0974 .980.917-BS:88C-24200 2.5T',
      },
    ],
    items: PRODUCT_DATA,
    action: {
      can_estimate_fee: false,
      is_loading_fee: false,
      is_sending: false
    }
  }
)